import React from 'react';
import { Link } from "react-router-dom";
import './Navbar.css';

export const Navbar = ({ cssClass }) => {
  return (
        <nav className={`wordpay-demo__navbar ${cssClass ? cssClass : ''}`}>
            <div className='wordpay-demo__navbar-title'>
              <Link to="/" className='wordpay-demo__navbar-title-link'>Wordpay DemoPage</Link>
            </div>
            <div className='wordpay-demo__navbar-links'>
                <Link className='wordpay-demo__navbar-single-link' to="/politics">Politics</Link>
                <Link className='wordpay-demo__navbar-single-link' to="/sport">Sport</Link>
                <Link className='wordpay-demo__navbar-single-link' to="/lifestyle">Lifestyle</Link>
            </div>
        </nav>
  )
}